
export default {
  data() {
    return {
      title:
        "Resources | Get a Bikeflights.com Logo | Vector Logos | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "affiliate",
          name: "affiliate",
          content:
            "Join for free and make money every time your site or app drives someone to book with us.",
        },
      ],
    };
  },
};
